// extracted by mini-css-extract-plugin
export default {"root":"ForgotPasswordSuccess_root__Hmwv6","subTitle":"ForgotPasswordSuccess_subTitle__fL20b"};